/**
 * @description
 * Collapse functions
 */

export default function initCollapse() {
    $('.dd-m-card--collapse-item__btn').on('click', (e) => {
        e.preventDefault();
        const $parent = $(e.currentTarget).closest('.dd-m-card--collapse-item');
        $(e.currentTarget).toggleClass('open');
        $parent.find('.dd-m-card--collapse-item__content').slideToggle('fast');
        $parent.toggleClass('is-open');
    });
}



// WEBPACK FOOTER //
// ./resources/site/js/components/collapse.js